module.exports = __webpack_public_path__ + "img/CM.ba54753b.jpg";